<div [@section] *ngIf="showWidget" class="connection-informer">
  <div class="top">
    <app-icon [width]="24" [height]="24" icon="no-connection-icon"></app-icon>
    <span>{{'no-internet.title' | customLocale}}</span>
  </div>
  <div class="text">{{'no-internet.text' | customLocale}}</div>
</div>
